<p-toast />

<!-- Session-expired modal (blocking, single "Sign in again" button). Lives
     at the shell level so it can overlay any feature; visibility is driven
     by SessionService state — see session.service.ts. -->
<app-session-expired-dialog />

<!-- Auth error from callback (e.g. user not a member of the organisation) -->
@if (authError()) {
  <div class="auth-initialising">
    <p class="auth-error">
      Sign-in failed: {{ authError()?.message }}
    </p>
  </div>
} @else if (isLoading()) {
  <!-- Auth0 SDK initialising or processing the redirect callback -->
  <div class="auth-initialising">
    <p-progressSpinner strokeWidth="3" ariaLabel="Loading" />
  </div>
} @else if (!isAuthenticated()) {
  <!-- Guard is resolving the org and will redirect — no blank flash -->
  <div class="auth-initialising">
    <p-progressSpinner strokeWidth="3" ariaLabel="Resolving organisation" />
    <p class="auth-message">Resolving your organisation&hellip;</p>
  </div>
} @else {
  <lib-app-header />
  <lib-side-nav />
}

<!--
  Router outlet is ALWAYS in the DOM regardless of auth state.
  This is critical — removing the outlet during the Auth0 callback phase
  can interfere with the router's navigation lifecycle and the guard's
  Observable chain. The guard still controls what renders inside it.
-->
<main class="app-main" [class.app-main--hidden]="!isAuthenticated() || isLoading() || authError()">
  <router-outlet />
</main>
